import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { IFireDepartmentBcTurnover } from "../../interfaces/firedepartment-bc-turnover/firedepartmentBcTurnover";
import { IPicklistValuesData } from "../../interfaces/administration/picklistValuesData";
import { ICarryoverComments } from "../../interfaces/firedepartment-bc-turnover/firedepartmentCarryoverComments";
import { FireDepartmentsBcTurnoversService } from "../../services/firedepartments/fireDepartmentsBcTurnovers.service";
import { LoggedUserService } from "../../services/common/logged-user.service";
import { ILoggedUserData } from "../../interfaces/common/loggedUserData";

@Component({
  selector: "app-carryover-comments-create",
  templateUrl: "./carryover-comments-create.component.html",
  styles: [
    `
      .button-container {
        display: flex !important;
        justify-content: space-between !important;
        margin: 10px 0px 0px 0px;
      }
    `,
  ],
})
export class CaryoverCommentsCreateComponent implements OnInit {
  // Input to receive data from parent component if needed
  @Input() bcTurnover: IFireDepartmentBcTurnover;

  // Output events to communicate with parent
  @Output() saved = new EventEmitter<any>();
  @Output() cancelled = new EventEmitter<void>();

  carryoverForm: FormGroup;
  dateAdded: Date = new Date();
  addedBy: string = "";
  validationMessages: string[] = [];
  today: Date = new Date();

  selectedShift: IPicklistValuesData;
  selectedCrew: IPicklistValuesData;
  currentUser: ILoggedUserData;

  constructor(
    private fb: FormBuilder,
    private fireDepartmentsBcTurnoversService: FireDepartmentsBcTurnoversService,
    private loggedUserService: LoggedUserService
  ) {
    this.createForm();
  }

  ngOnInit(): void {
    this.loggedUserService.getLoggedUserData().subscribe((user) => {
      this.currentUser = user;
      this.addedBy = `${user?.firstName} ${user?.lastName}`;
    });
    this.carryoverForm
      .get("comments")
      .setValue(this.bcTurnover?.initialComments);
  }

  createForm(): void {
    this.carryoverForm = this.fb.group({
      crew: ["-1", Validators.required],
      shift: ["-1", Validators.required],
      comments: [this.bcTurnover?.initialComments, Validators.required],
    });
  }

  // Note: Fixed the form name discrepancy from the HTML
  get turnoverForm(): FormGroup {
    return this.carryoverForm;
  }

  onCrewSelected(crew: IPicklistValuesData): void {
    this.selectedCrew = crew;
  }

  onShiftSelected(shift: IPicklistValuesData): void {
    this.selectedShift = shift;
  }

  submit(): void {
    this.validationMessages = [];
    if (this.carryoverForm.get("comments").value === "") {
      this.validationMessages.push("Comments are required.");
    }

    if (
      this.carryoverForm.get("crew").value === "" ||
      this.carryoverForm.get("crew").value === "-1"
    ) {
      this.validationMessages.push("Crew is required.");
    }

    if (
      this.carryoverForm.get("shift").value === "" ||
      this.carryoverForm.get("shift").value === "-1"
    ) {
      this.validationMessages.push("Shift is required.");
    }

    if (this.validationMessages.length > 0) {
      return;
    }

    if (this.carryoverForm.valid) {
      const data: ICarryoverComments = {
        id: 0,
        dateAdded: this.today,
        createdById: this.currentUser?.id,
        turnoverId: this.bcTurnover.id,
        comments: this.carryoverForm.get("comments").value,
        crewId: this.selectedCrew.id,
        shiftId: this.selectedShift.id,
        picklistValues: [
          {
            id: this.selectedCrew.id,
            value: this.selectedCrew.value,
            picklistFieldId: this.selectedCrew.picklistFieldId,
            facilityId: Number(this.currentUser?.facilityId) || 1,
          },
          {
            id: this.selectedShift.id,
            value: this.selectedShift.value,
            picklistFieldId: this.selectedShift.picklistFieldId,
            facilityId: Number(this.currentUser?.facilityId) || 1,
          },
        ],
      };

      this.fireDepartmentsBcTurnoversService
        .createCarryoverComments(data)
        .subscribe((data) => {
          this.carryoverForm.reset();
          this.saved.emit(data);
        });
    } else {
      // Mark all fields as touched to trigger validation messages
      Object.keys(this.carryoverForm.controls).forEach((key) => {
        this.carryoverForm.get(key)?.markAsTouched();
      });
    }
  }

  cancel(): void {
    this.carryoverForm.reset();
    this.cancelled.emit();
  }
}
